import Vue from 'vue';
import Router from 'vue-router';
import uniqueReferralPage from './referral/referralHome/referralHome.vue';

import { referralRoutes } from './referral';

Vue.use(Router);

const appRoutes = [
  {
    path: '/:id/:ghostuid',
    component: uniqueReferralPage,
  },
  {
    path: '/:id',
    component: uniqueReferralPage,
  },
  {
    path: '/',
    component: uniqueReferralPage,
  },
  {
    path: '',
    component: uniqueReferralPage,
  },
  {
    path: '*',
    redirect: uniqueReferralPage,
  },
];

const routes = [...appRoutes, ...referralRoutes];

const router = new Router({
  mode: 'history',
  routes,
});


export default router;
